import React from 'react';

const SOCIAL_DEFAULTS = {
  youtube:   'https://youtube.com/@zionaogooty?si=puamBJok11hz-E05',
  facebook:  'https://www.facebook.com/share/1HL7j1WzfT/?mibextid=wwXIfr',
  instagram: 'https://www.instagram.com/zionagooty?igsh=bjhtY3d6ajFhcGhx',
};

function useContactInfo() {
  const [info, setInfo] = React.useState({
    phone:'+91 73975 47474', email:'zionaog.fernhill@gmail.com',
    phoneEnabled:true, emailEnabled:true,
    youtube: SOCIAL_DEFAULTS.youtube,
    facebook: SOCIAL_DEFAULTS.facebook,
    instagram: SOCIAL_DEFAULTS.instagram,
  });
  React.useEffect(() => {
    import('../lib/supabaseClient').then(({ supabase }) => {
      supabase.from('church_settings').select('key,value')
        .then(({ data }) => {
          if (data) {
            const m = {};
            data.forEach(r => { m[r.key] = r.value; });
            setInfo(prev => ({
              phone:    m.church_phone    || prev.phone,
              email:    m.church_email    || prev.email,
              phoneEnabled: m.church_phone_enabled !== 'false',
              emailEnabled: m.church_email_enabled !== 'false',
              youtube:   m.social_youtube   || prev.youtube,
              facebook:  m.social_facebook  || prev.facebook,
              instagram: m.social_instagram || prev.instagram,
            }));
          }
        });
    });
  }, []);
  return info;
}

function getSocials(contactInfo) {
  return [
    { key:'youtube',   label:'YouTube',   icon:'▶',  href: contactInfo.youtube,  bg:'linear-gradient(135deg,#ff0000,#cc0000)', desc:'Watch sermons & live services' },
    { key:'facebook',  label:'Facebook',  icon:'f',  href: contactInfo.facebook, bg:'linear-gradient(135deg,#1877f2,#0d5bba)', desc:'Updates, events & community' },
    { key:'instagram', label:'Instagram', icon:'📷', href: contactInfo.instagram,bg:'linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366)', desc:'Photos, reels & inspiration' },
    { key:'whatsapp',  label:'WhatsApp',  icon:'💬', href:`https://wa.me/${contactInfo.phone.replace(/[^0-9]/g,'')}`, bg:'linear-gradient(135deg,#25d366,#128c7e)', desc:'Chat & prayer requests' },
  ];
}

export default function Connect() {
  const contactInfo = useContactInfo();
  const socials = getSocials(contactInfo);
  return (
    <section id="connect" className="section" style={{ background: 'linear-gradient(180deg,var(--bg-deep) 0%,#040a16 100%)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Stay Connected</span>
          <h2 className="section-title">Follow <span>Us Online</span></h2>
          <div className="divider center" />
        </div>

        {/* Social Grid */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:20, maxWidth:960, margin:'0 auto 60px' }}>
          {socials.map((s) => {
            if (s.key === 'whatsapp' && !contactInfo.phoneEnabled) return null;
            return (
            <a key={s.key}
              href={s.href}
              target="_blank" rel="noreferrer" className="fade-up"
              style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:12, padding:'30px 24px', borderRadius:18, background:'rgba(13,27,62,0.8)', border:'1px solid rgba(201,168,76,0.18)', textDecoration:'none', transition:'all 0.28s' }}
              onMouseEnter={e => { e.currentTarget.style.transform='translateY(-7px)'; e.currentTarget.style.boxShadow='0 18px 50px rgba(0,0,0,0.5)'; e.currentTarget.style.borderColor='rgba(201,168,76,0.55)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='none'; e.currentTarget.style.borderColor='rgba(201,168,76,0.18)'; }}
            >
              <div style={{ width:58, height:58, borderRadius:'50%', background:s.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.4rem', color:'#fff', boxShadow:'0 6px 20px rgba(0,0,0,0.4)', fontWeight:900, fontFamily:'serif' }}>
                {s.icon}
              </div>
              <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.82rem', color:'#f0e8d8', letterSpacing:'0.05em' }}>{s.label}</div>
              <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', textAlign:'center', lineHeight:1.5 }}>{s.desc}</div>
            </a>
            );
          })}
        </div>

        {/* Contact Info + Map */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:28, maxWidth:1000, margin:'0 auto' }} className="connect-grid">

          {/* Left — Contact details */}
          <div className="fade-up" style={{ display:'flex', flexDirection:'column', gap:16 }}>

            {/* Address */}
            <div style={{ display:'flex', gap:14, padding:'20px 22px', background:'rgba(13,27,62,0.7)', border:'1px solid rgba(201,168,76,0.15)', borderRadius:14 }}>
              <span style={{ fontSize:'1.4rem', flexShrink:0, marginTop:2 }}>📍</span>
              <div>
                <div style={{ fontSize:'0.68rem', letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--primary)', fontWeight:700, marginBottom:6 }}>Address</div>
                <p style={{ fontFamily:"'Crimson Pro',serif", fontSize:'0.98rem', color:'var(--text-muted)', lineHeight:1.65 }}>
                  Near Gel Memorial School,<br/>
                  Church Road, Fernhill,<br/>
                  Ooty – 643004, Tamil Nadu, India
                </p>
                <a href="https://maps.google.com/?q=Zion+Assemblies+of+God+Church+Fernhill+Ooty" target="_blank" rel="noreferrer"
                  style={{ display:'inline-block', marginTop:10, fontSize:'0.78rem', color:'var(--primary)', textDecoration:'none', border:'1px solid rgba(201,168,76,0.35)', padding:'5px 14px', borderRadius:20, transition:'background 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.background='rgba(201,168,76,0.1)'}
                  onMouseLeave={e => e.currentTarget.style.background='transparent'}
                >
                  🗺️ Open in Google Maps
                </a>
              </div>
            </div>

            {/* Phone — only show if enabled */}
            {contactInfo.phoneEnabled && (
            <div style={{ display:'flex', gap:14, padding:'20px 22px', background:'rgba(13,27,62,0.7)', border:'1px solid rgba(201,168,76,0.15)', borderRadius:14 }}>
              <span style={{ fontSize:'1.4rem', flexShrink:0, marginTop:2 }}>📞</span>
              <div>
                <div style={{ fontSize:'0.68rem', letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--primary)', fontWeight:700, marginBottom:6 }}>Phone</div>
                <a href={`tel:${contactInfo.phone.replace(/[^0-9+]/g,'')}`} style={{ fontFamily:"'Crimson Pro',serif", fontSize:'1.1rem', color:'#f0e8d8', textDecoration:'none', display:'block', marginBottom:4 }}>
                  {contactInfo.phone}
                </a>
                <div style={{ display:'flex', gap:10, marginTop:8 }}>
                  <a href={`tel:${contactInfo.phone.replace(/[^0-9+]/g,'')}`}
                    style={{ fontSize:'0.74rem', color:'var(--primary)', textDecoration:'none', border:'1px solid rgba(201,168,76,0.35)', padding:'5px 14px', borderRadius:20, transition:'background 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.background='rgba(201,168,76,0.1)'}
                    onMouseLeave={e => e.currentTarget.style.background='transparent'}
                  >📞 Call Now</a>
                  <a href={`https://wa.me/${contactInfo.phone.replace(/[^0-9]/g,'')}`}
                    target="_blank" rel="noreferrer"
                    style={{ fontSize:'0.74rem', color:'#5cb85c', textDecoration:'none', border:'1px solid rgba(92,184,92,0.35)', padding:'5px 14px', borderRadius:20, transition:'background 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.background='rgba(92,184,92,0.1)'}
                    onMouseLeave={e => e.currentTarget.style.background='transparent'}
                  >💬 WhatsApp</a>
                </div>
              </div>
            </div>
            )}

            {/* Service Times */}
            <div style={{ display:'flex', gap:14, padding:'20px 22px', background:'rgba(13,27,62,0.7)', border:'1px solid rgba(201,168,76,0.15)', borderRadius:14 }}>
              <span style={{ fontSize:'1.4rem', flexShrink:0, marginTop:2 }}>⏰</span>
              <div>
                <div style={{ fontSize:'0.68rem', letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--primary)', fontWeight:700, marginBottom:6 }}>Service Times</div>
                <p style={{ fontFamily:"'Crimson Pro',serif", fontSize:'0.98rem', color:'var(--text-muted)', lineHeight:1.75 }}>
                  Sunday: 6:30 AM & 9:30 AM<br/>
                  Daily Prayer: 10:00 AM every day<br/>
                  <span style={{ color:'rgba(201,168,76,0.7)', fontSize:'0.88rem' }}>365 days a year 🙏</span>
                </p>
              </div>
            </div>
          </div>

          {/* Right — Google Map embed */}
          <div className="fade-up" style={{ borderRadius:16, overflow:'hidden', border:'1px solid rgba(201,168,76,0.25)', boxShadow:'0 8px 40px rgba(0,0,0,0.4)', minHeight:320 }}>
            <iframe
              title="Zion AG Church Location"
              src="https://maps.google.com/maps?q=Zion+Assemblies+of+God+Church+Fernhill+Ooty+Tamil+Nadu&hl=en&z=16&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block', minHeight: 360 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width:700px){
          .connect-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
